import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { log } from '../utils/logger';
import HomePage from './HomePage';
import Dashboard from './Dashboard';

const UnifiedDashboard = () => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const [showFallback, setShowFallback] = useState(false);

  log('🚀 UnifiedDashboard render:', { isLoading, isAuthenticated, user: user ? 'Present' : 'None' });

  // Fallback mechanism - if loading takes too long, show the homepage
  useEffect(() => {
    if (isLoading) {
      const fallbackTimer = setTimeout(() => {
        console.warn('🚨 Loading fallback triggered - showing homepage');
        setShowFallback(true);
      }, 2000); // 2 second fallback

      return () => clearTimeout(fallbackTimer);
    } else {
      setShowFallback(false);
    }
  }, [isLoading]);

  // If we've triggered the fallback or auth is complete
  if (showFallback || !isLoading) {
    if (isAuthenticated && user) {
      log('✅ Showing authenticated dashboard');
      return <Dashboard />;
    }
    
    log('🏠 Showing marketing homepage');
    return <HomePage />;
  }

  // Only show loading for a very brief moment
  console.log('⏳ Brief loading screen...');
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 dark:from-black dark:to-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="text-4xl mb-4">🎮</div>
        <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">Loading EightyThreeLabs...</h2>
        <p className="text-gray-600 dark:text-gray-200">Setting up your experience</p>
        <div className="mt-4">
          <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
        </div>
      </div>
    </div>
  );
};

export default UnifiedDashboard;